import type { FC } from 'react';
import { MarkdownContent, Date, Title } from '../../share';

const terms = `
## 第1条（目的）
本規約は、そぽたん商店（以下「当開発チーム」といいます。）が提供する「Pay Crew2」という名称のサービス（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスは、個人間またはグループ間での貸借の記録、管理、および合算を目的として提供されます。

## 第2条（定義）
本規約において使用する用語の定義は、以下の通りとします。
1.  「利用者」とは、本規約に同意の上、当開発チームが提供する本サービスを利用する個人または法人をいいます。
2.  「貸借登録」とは、利用者が本サービス上で、金銭の貸し借りに関する情報を登録することをいいます。
3.  「台帳」とは、利用者が登録した貸借情報を記録したものをいいます。
4.  「返金処理」とは、利用者が登録した貸借記録に対して、返金が行われた旨を記録する処理をいいます。
5.  「返金処理の取り消し」とは、誤って登録された返金処理を元に戻す処理をいいます。
6.  「IdP」とは、Identity Provider（認証プロバイダー）の略であり、本サービスではGoogleおよびDiscordの認証システムを利用します。
7.  「better-auth」とは、当開発チームが利用するnpm packageを指します。

## 第3条（本サービスの概要）
1.  当開発チームは、以下の機能を提供する本サービスを運営します。
    1.  貸借の登録機能
    2.  登録された貸借情報を記録する共通の台帳機能
    3.  複数のグループを越えた個人間の貸借の合算表示機能
    4.  登録された台帳記録に対する返金処理機能
    5.  返金処理の取り消し機能
2.  本サービスは、貸借の記録および管理を支援するものであり、実際に金銭の授受を伴う取引は行いません。利用者は、本サービス外で当事者間で直接金銭のやり取りを行うものとします。

## 第4条（利用者の義務）
1.  利用者は、本規約および関連法令を遵守し、本サービスを適法かつ公正に利用しなければなりません。
2.  利用者は、自己の責任において、本サービスへのログイン情報（GoogleまたはDiscordのアカウント情報）を厳重に管理し、第三者に漏洩しないように努めなければなりません。
3.  利用者は、本サービスを利用して登録する情報が、真実かつ正確であることを保証するものとします。
4.  利用者は、本サービスを利用して第三者の権利を侵害する行為、またはそのおそれのある行為を行ってはなりません。

## 第5条（禁止事項）
利用者は、本サービスの利用にあたり、以下の各号に定める行為を行ってはなりません。
1.  法令または公序良俗に違反する行為
2.  犯罪行為に関連する行為
3.  当開発チーム、他の利用者、または第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利または利益を侵害する行為
4.  本サービスを不正な目的で利用する行為
5.  本サービスの運営を妨害するおそれのある行為
6.  本サービスに接続しているネットワークまたはシステムに過度の負担をかける行為
7.  本サービスのシステムに不正にアクセスし、またはそのおそれのある行為
8.  第三者のIdPアカウントを不正に利用する行為
9.  その他、当開発チームが不適切と判断する行為

## 第6条（個人情報および登録データの取扱い）
1.  当開発チームは、本サービスの提供にあたり、以下の情報を収集します。
    1.  better-authを利用したGoogleおよびDiscordのIdPを使用した認証システムを構築するために必要な情報（氏名、メールアドレス、プロフィール情報など、IdPから提供される範囲に限ります。）
    2.  利用者が本サービスの台帳に記載した貸借に関するデータ
2.  当開発チームは、収集した個人情報および登録データを、本サービスの提供、改善、および維持のためにのみ利用します。
3.  当開発チームは、個人情報保護法および関連法令を遵守し、利用者の個人情報を適切に管理します。詳細については、別途定めるプライバシーポリシーに従うものとします。

## 第7条（本サービスの変更、中断、終了）
1.  当開発チームは、利用者に事前に通知することなく、本サービスの全部または一部の内容を変更し、または提供を中断もしくは終了することができるものとします。
2.  当開発チームは、以下のいずれかの事由が生じた場合には、利用者に事前に通知することなく、本サービスの提供を一時的に中断することができるものとします。
    1.  本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合
    2.  コンピューター・システムが火災、停電、地震、その他の非常事態により、本サービスの提供が困難となった場合
    3.  コンピューター・システムに障害が発生し、またはそのおそれがある場合
    4.  その他、当開発チームが本サービスの提供の一時的な中断が必要と判断した場合
3.  当開発チームは、本サービスの提供の変更、中断、または終了によって、利用者または第三者に生じた損害について、一切の責任を負いません。
4.  当開発チームは、利用者に予告なくサービスを終了し、全てのデータを破棄することがあります。

## 第8条（システム構成および依存サービスの変更）
当開発チームは、本サービスの安定的な提供および機能向上のため、システム構成や依存している外部サービス（IdPを含む）を変更する可能性があります。これにより、本サービスの機能や利用方法に変更が生じる場合があります。当開発チームは、かかる変更について、可能な限り利用者に通知するよう努めますが、事前の通知なく変更を行う場合があることを利用者は予め承諾するものとします。

## 第9条（知的財産権）
1.  本サービスにおいて当開発チームが提供するコンテンツに関する著作権その他の知的財産権は、すべて当開発チームまたは当開発チームに正当な権利を有する第三者に帰属します。
2.  利用者は、本サービスを通じて提供されるいかなるコンテンツについても、当開発チームの許諾なく、複製、譲渡、貸与、翻訳、翻案、公衆送信等を行うことはできません。

## 第10条（免責事項）
1.  当開発チームは、本サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者にとって有用であること、および利用者に適用のある法令または業界団体の内部規則等に適合することについて、何ら保証するものではありません。
2.  当開発チームは、本サービスに起因して利用者に生じたあらゆる損害について、当開発チームの故意または重過失による場合を除き、一切の責任を負いません。ただし、本サービスに関する当開発チームと利用者の間の契約が消費者契約法に定める消費者契約となる場合、この免責規定は適用されませんが、かかる場合であっても、当開発チームの過失（重過失を除く）による債務不履行または不法行為により利用者に生じた損害のうち特別な事情によって生じた損害（当開発チームまたは利用者が予見し、または予見し得た場合を含む）については、一切の責任を負いません。
3.  当開発チームは、本サービスに関して、利用者間または利用者と第三者との間で生じた一切の紛争について、関知せず、一切の責任を負いません。

## 第11条（規約の変更）
1.  当開発チームは、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができるものとします。
2.  当開発チームは、利用者が変更後の規約に同意しない場合、本サービスの利用を継続できないことを利用者は予め承諾するものとします。

## 第12条（準拠法・裁判管轄）
1.  本規約の解釈にあたっては、日本法を準拠法とします。
2.  本サービスに関して紛争が生じた場合には、当開発チームの本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。

以上
`;

const Terms: FC = () => {
  return (
    <>
      <Title title="利用規約" />
      <Date content="最終更新日：2026年1月21日" />
      <MarkdownContent content={terms} />
    </>
  );
};

export default Terms;
